import { render, staticRenderFns } from "./Administrative.vue?vue&type=template&id=6311dccc&scoped=true"
import script from "./Administrative.vue?vue&type=script&lang=js"
export * from "./Administrative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311dccc",
  null
  
)

export default component.exports